import axios from "axios";
import { useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import ProfileHeader from "./ProfileHeader";
import "./userProfiles/MentorProfile.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";


function UpcomingMeetings() {
    const { userData } = useAuth();
    const [meetingData, setMeetingData] = useState(null);


    useEffect(() => {
        const fetchMeetings = async () => {
            try {
                const tutorId = userData.role === "experts" ? userData.expertId : userData.mentorId;
                const tutorType = userData.role === "experts" ? "expert" : "mentor";

                const response = await axios.post(`${BASE_URL}/getUpcomingMeetingsForTutor.php`, {
                    tutorId,
                    tutorType
                });
                
                const data = response.data;
                setMeetingData(data);
            } catch (error) {
                console.error("Error fetching mentor meetings:", error);
            }
        };

        fetchMeetings();
    }, []);

    // Function to convert time to 12-hour format
    const formatTo12Hr = (time) => {
        const [hour, minute] = time.split(":");
        const formattedHour = hour % 12 || 12;
        const period = hour >= 12 ? "PM" : "AM";
        return `${formattedHour}:${minute} ${period}`;
    };


    const formatToDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <div>
            <ProfileHeader />
            <div className="mentor-profile-body">
                <h2>Your Upcoming Meetings:</h2>
                {meetingData && meetingData.length > 0 ? (
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Time</th>
                                <th>With</th>
                                <th>Charge</th>
                                <th>Created At</th>
                                <th>Rating</th>
                                <th>Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {meetingData.map((meeting) => (
                                <tr key={meeting.meetingId}>
                                    <td>{formatToDate(meeting.meetingDate)}</td>
                                    <td>{meeting.meetingTime}</td>
                                    <td>{meeting.userName}</td>
                                    <td>{meeting.meetingCharge}</td>
                                    <td>{meeting.createdAt}</td>
                                    <td>{meeting.rating > 0 ?
                                        (<span>⭐{parseFloat(meeting.rating).toFixed(1)}</span>
                                        ) : (
                                            <span>Not rated.</span>
                                        )}
                                    </td>
                                    <td><a href={meeting.meetingLink}>Link</a></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p>No meetings scheduled.</p>
                )}
            </div>
        </div>
    );
}

export default UpcomingMeetings;
